import createConfigurableObject from '../../../utils/configurationObject';

export default (app) => {
    app.sideMenuItems = app.sideMenuItems || createConfigurableObject();
};
